var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-court-of-protection-warning"},[_vm._v("THIS CLIENT IS MARKED AS COP")])}
var staticRenderFns = []

export { render, staticRenderFns }